import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered modal-lg",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "accessnotes-modal-label"
}, " Access confirmation ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "modal-footer" }

import $ from 'jquery';
import { ref, inject, watch } from 'vue';
import { v4 as uuidv4 } from 'uuid';
import { Booking } from '@/models';
import { useToast } from "vue-toastification";
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import TiptapEditor from '@/components/editor/TiptapEditor.vue';

// defineProps to specify the type of props

export default /*#__PURE__*/_defineComponent({
  __name: 'AccessnotesDialog',
  props: {
    name: {},
    booking: {}
  },
  emits: ['hide'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

// States
const tiptapeditorkey = ref<string>('');
const tiptapaccessnotes = ref<string>('');

const store = useStore();
const route = useRoute();

// Actions
const setBookingDeep = async (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('diary/setBookingDeep', payload);
};

const saveBooking = async (booking: Booking): Promise<any> => {
  return store.dispatch('diary/saveBooking', booking);
};

// Mutations
const resetUnsavedChanges = () => {
  store.commit('diary/resetUnsavedChanges');
};

// Injected properties
const actProperty: any = inject('actProperty');
const toasted = useToast();
const emit = __emit;

// Watches
watch(() => props.booking, (newValue) => {
  tiptapaccessnotes.value = newValue.accessnotes;
});

// Methods
const init = () => {
  tiptapeditorkey.value = uuidv4();
  tiptapaccessnotes.value = props.booking.accessnotes;
};

const setAccessnotes = (val: string) => {
  tiptapaccessnotes.value = val;
};

const save = async () => {
  await setBookingDeep({path: 'accessnotes', data: tiptapaccessnotes.value });
  if (!isNewBooking()) {
    await saveBooking(props.booking)
      .then(() => resetUnsavedChanges())
      .catch((err: any) => toasted.error(err.message));
  }
  hide();
};

const isNewBooking = (): boolean => {
  return route.params.id === "new";
};

const show = () => {
  if ($(`#${props.name}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.name + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.name}`).show();
  }
}
const hide = () => {
  if ($(`#${props.name}`).length > 0) {
    $(`#${props.name}` + 'Backdrop').remove();
    $(`#${props.name}`).hide();
  }
};
__expose({init, show, hide});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.name,
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`accessnotes-modal-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", {
            id: "close",
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("form", null, [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", null, [
                (_openBlock(), _createBlock(TiptapEditor, {
                  key: tiptapeditorkey.value,
                  content: tiptapaccessnotes.value,
                  onBlur: setAccessnotes,
                  style: {"min-height":"50vh"}
                }, null, 8, ["content"]))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            "data-dismiss": "modal",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, " Cancel "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            "data-dismiss": "modal",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (save()), ["prevent"]))
          }, " Ok ")
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})